<template>
    <div class="container_active">
          <div class="box_lg_br">
                    <div class="box_svg">
                        <img src="@/assets/check.svg" alt="">
                         <p>{{get_local_string.string_101}}</p>
                    </div>
                    <form @submit.prevent="checkCode()" @keydown="formInput($event)" class="active_code">
                        <div class="d-flex mb-3">
                          <input v-model="input_check.code1" @keydown="nextFocus($event)" type="number" maxlength="1" pattern="[0-9]" class="form-control active_input first">
                          <input v-model="input_check.code2" @keydown="nextFocus($event)" type="number" maxlength="1" pattern="[0-9]" class="form-control active_input">
                          <input v-model="input_check.code3" @keydown="nextFocus($event)" type="number" maxlength="1" pattern="[0-9]" class="form-control active_input">
                          <input v-model="input_check.code4" @keydown="nextFocus($event)" type="number" maxlength="1" pattern="[0-9]" class="form-control active_input">
                          <input v-model="input_check.code5" @keydown="nextFocus($event)" type="number" maxlength="1" pattern="[0-9]" class="form-control active_input">
                          <input v-model="input_check.code6" @keydown="nextFocus($event)" type="number" pattern="[0-9]" maxlength = "1" :volume="1" class="form-control active_input last">
                        </div>
                        <div class="text-center">
                            <button class="yes" type="submit"><i class="fas fa-sms"></i> <span>{{get_local_string.string_64}}</span></button>
                        </div>
                          <b-loading :is-full-page="isFullPage" v-model="isLoading"  animation="faed" >
                            <b-icon
                                pack="fas"
                                icon="spinner"
                                size="is-large"
                                custom-class="fa-spin"
                                >
                            </b-icon>
                        </b-loading>
                      </form>
                </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
   name:'ActivCodeApp',

   data(){
       return{
           input_check:{
            code1:'',
            code2:'',
            code3:'',
            code4:'',
            code5:'',
            code6:'',
            
           },
        inputs : document.querySelectorAll('.active_input'),
        isLoading: false,
        isFullPage: false,
       }
   },
   computed:{
    ...mapGetters({
         user:'auth/user',
          get_local_string:'get_local_string'
    })
   },
   methods:{
       ...mapActions({
         activeSms:'activeSms',
       }),
       ...mapMutations({
           SET_USER:'auth/SET_USER'
       }),
       checkCode(){
           this.openLoading();
           let arr_input = [];
           arr_input.push(this.input_check.code1 , this.input_check.code2 ,  this.input_check.code3 ,  this.input_check.code4 ,  this.input_check.code5 ,  this.input_check.code6);
           let codesms = parseInt(arr_input.join(""));
            this.activeSms(codesms).then(()=>{
            console.log(this.$store.state.res_sms.data.data.code);
            if(this.$store.state.res_sms.status == 401)
            {   
                this.isLoading = false;
                console.log('error code sms 401')
            }
            else if(this.$store.state.res_sms.status == 200 ){
                 this.SET_USER(this.$store.state.res_sms.data.data);
                  if(this.user.is_vaild == 1)
                {
                    this.isLoading = false;
                     this.$router.replace('/Meny');
                }
                else{
                    this.isLoading = false;
                      this.$router.replace('/ActiveCode');
                }

            }
            })
       
       },
    //    keyCode(){
    //        console.log()
    //    },
       openLoading() {
                this.isLoading = true;
            },
       formInput(){
           document.addEventListener('input', this.handleInput)
       }
       ,
       nextFocus(e){
        //    console.log('switch' , e.keyCode)
           switch(e.keyCode) {
      case 8:
        this.handleBackspace(e)
        break
      case 37:
        this.handleArrowLeft(e)
        break
      case 39:
        this.handleArrowRight(e)
        break
      default:  
       }
       }
       ,

        handleInput(e) {
        const input = e.target;
        const nextInput = input.nextElementSibling
        if (nextInput && input.value) {
            nextInput.focus();
            if (nextInput.value) {
            nextInput.select();
            }
        }
        }
        ,
        handlePaste(e) {
        e.preventDefault()
        const paste = e.clipboardData.getData('text')
        this.inputs.forEach((input, i) => {
            input.value = paste[i] || ''
        })
        },

        handleBackspace(e) { 
        const input = e.target;
        if (input.value) {
            input.value = ''
            return;
        }

        if(input.classList.contains('first'))
        {
        return '0'
        }

        else{
        
            // input.value='';
            this.input_check.code6='';
            input.previousElementSibling.focus();
        }


        }
        ,
        handleArrowLeft(e) {
        const previousInput = e.target.previousElementSibling
        if (!previousInput) return
        previousInput.focus()
        },

        handleArrowRight(e) {
        const nextInput = e.target.nextElementSibling
        if (!nextInput) return
        nextInput.focus()
        }
            
   }
}
</script>
<!-- Helper Func Js -->
<style lang="scss" scoped>
.container_active{
    max-width: 600px;
    margin: 0 auto;
    padding-top: 160px;
}
.active_wrap {
    padding: 50px 0px;
}
.box_svg {
    /* margin-top: 50px; */
    height: 160px;
    text-align: center;
    color: gray;
}
.box_svg p {
    display: block;
    margin-bottom: 20px;
    margin-top: 20px;
    
}
.box_svg img {
    height: 100%;
    width: 100%;
    display: block;
}
.img_car_choosed {
    height: 200px;
}
.img_car_choosed img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}
.box_car_choosed {
    text-align: center;
    min-height: 300px;
    box-shadow: 1px 3px 14px gainsboro;
    padding: 30px 14px;
}
.car_name {
    font-size: 16px;
    font-weight: 500;
    margin-top: 10px;
    display: block;
}
.time_st_end {
    display: flex;
    margin-top: 10px;
    justify-content: center;
}
.left_st_end {
    margin-right: 13px;
    font-size: 15px;
    font-weight: 500;
}
.right_st_end {
    display: flex;
    flex-direction: column;
    font-size: 15px;
}
.total_pris {
    display: flex;
    justify-content: center;
    font-size: 25px;
    margin-top: 20px;
}
.totla_span {
    margin-right: 20px;
}

button.yes {
    padding: 8px 20px;
    border-radius: 30px;
    color: white;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-transform: capitalize;
    text-align: center;
    border: none;
}
a:hover {
    text-decoration: none;
}
button.yes {
    background-color: #02bfa6;
}
.felx_ok a.no {
    background-color: #f50057;
}
.felx_ok button i {
    font-size: 20px;
    margin-right: 4px;
}

.box_lg_br {
 height: 100%;
    padding: 60px 14px;
    box-shadow: 1px 3px 14px white;
    background-color: white;
    border-radius: 20px;
    position: relative;
}

/*  */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

form {
    padding: 1rem;
    border-radius: 4px;
    /* box-shadow: 0 2px 4px rgb(0 0 0 / 10%); */
    max-width: 400px;
    background: #fff;
    margin-top: 100px;
    margin: 50px auto 0px auto;
}
form .form-control {
    display: block;
    height: 50px;
    margin-right: 0.5rem;
    text-align: center;
    font-size: 1.25rem;
    min-width: 0;
}
form .form-control:last-child {
    margin-right: 0;
}
/*  */

@media (max-width: 992px) {
    form {
        font-size: 14px;
        flex-direction: column;
        margin-top: 70px;
    }
    button.yes {
        margin-top: 10px;
    }
}

</style>